import { createListReducer } from 'Services/reducerCreator';

export default createListReducer('QUIZZ_LIST');
